import type { ControlBridgeQueueItem } from '../deriveViewModel';

/** Journal / WBS queue rows that must not appear as Drive flow nodes (drill-down only). */
const COORDINATION_ITEM_ID =
  /^(co-pia-|co-poi-iss-|ai-act-|co-pim-|co-pwp-|co-pbs-|co-kfo-pia-|co-kso-pia-|co-prm-)/i;

/** True when a queue row is coordination-layer work, not an operational value-flow subject. */
export function isCoordinationLayerFlowItem(item: ControlBridgeQueueItem): boolean {
  if (item.issueType) return true;
  if (item.activityTargetState) return true;
  if (item.improvementRef && COORDINATION_ITEM_ID.test(item.itemId)) return true;
  if (COORDINATION_ITEM_ID.test(item.itemId)) return true;
  return false;
}

export function driveOperationalFlowItems(items: ControlBridgeQueueItem[]): ControlBridgeQueueItem[] {
  return items.filter((item) => !isCoordinationLayerFlowItem(item));
}
